import { Prop, Schema, SchemaFactory } from '@nestjs/mongoose';
import { Document, Types } from 'mongoose';
import { BaseMongoEntity } from '@/common/entities/base.entity';

export type CustomerStatisticsDocument = CustomerStatistics & Document;

@Schema({ timestamps: true })
export class CustomerStatistics extends BaseMongoEntity {
  @Prop({ type: String, required: true, unique: true, index: true })
  phone: string; // رقم الموبايل كمعرف فريد للعميل

  @Prop({ type: String, required: false })
  fullName?: string; // اسم العميل

  @Prop({ type: Number, default: 0 })
  orderCount: number; // عدد الطلبات

  @Prop({ type: Number, default: 0 })
  totalAmount: number; // مجموع المبلغ لجميع الأوردرات

  @Prop({ type: Types.ObjectId, ref: 'State', required: false })
  state?: Types.ObjectId; // المحافظة/الولاية

  @Prop({ type: Types.ObjectId, ref: 'Country', required: false })
  country?: Types.ObjectId; // الدولة

  @Prop({ type: String, required: false })
  city?: string; // المدينة

  @Prop({ type: String, required: false })
  address?: string; // العنوان الكامل

  @Prop({ type: Date, default: Date.now })
  lastOrderDate?: Date; // تاريخ آخر طلب

  @Prop({ type: Date, default: Date.now })
  firstOrderDate?: Date; // تاريخ أول طلب
}

export const CustomerStatisticsSchema = SchemaFactory.createForClass(CustomerStatistics);

// Indexes for better performance
CustomerStatisticsSchema.index({ phone: 1 });
CustomerStatisticsSchema.index({ orderCount: -1 });
CustomerStatisticsSchema.index({ totalAmount: -1 });
CustomerStatisticsSchema.index({ state: 1 });
CustomerStatisticsSchema.index({ country: 1 });
CustomerStatisticsSchema.index({ lastOrderDate: -1 });

